module.exports = __webpack_public_path__ + "static/media/797.e109cfbd.jpg";